<template>
  <a-tooltip>
    <template slot="title">指标过滤</template>
    <a-dropdown>
      <!-- <a-button type="link" icon="control" /> -->
      <a-button type="link">
        <img :src="filterMaterial" alt="指标过滤" />
      </a-button>
      <a-menu slot="overlay" class="menu">
        <!-- <a-radio-group :defaultValue="indexFilter" :options="nutTypesRadio" @change="e => filterChange(e.target.value)" /> -->
        <a-menu-item>
          <span :style="{color: indexFilter === 0 ?'#1890ff':''}" @click="() => filterChange(0)">显示所有指标</span>
        </a-menu-item>
        <a-menu-item>
          <span :style="{color: indexFilter === 1 ?'#1890ff':''}" @click="() => filterChange(1)">仅展示有值的指标</span>
        </a-menu-item>
        <a-menu-item>
          <span :style="{color: indexFilter === 2 ?'#1890ff':''}" @click="() => filterChange(2)">仅展示有约束的指标</span>
        </a-menu-item>
      </a-menu>
    </a-dropdown>
  </a-tooltip>
</template>

<script>
import {nhfMixins} from '../../untils'
import filterMaterial from '@/assets/images/icon/filterMaterial.png'
export default {
  mixins:[nhfMixins],
  data(){
    return {
      nutTypesRadio:[
        { label: '显示所有指标', value: 0 },
        { label: '仅展示有值的指标', value: 1 },
        { label: '仅展示有约束的指标', value: 2 },
      ],
      filterMaterial
    }
  },
  mounted(){
    let indexFilter = window.localStorage.getItem('indexFilter')
    if(indexFilter) this.filterChange(Number(indexFilter))
  },
  methods:{
    async filterChange(val){
      let filterAction = null
      window.localStorage.setItem('indexFilter',val)
      this.setState({indexFilter:val})
      if(val == 1) filterAction = i => i.content > 0 || i.content < 0
      if(val == 2) filterAction = i => i.minValue || i.minValue === 0  || i.maxValue || i.maxValue === 0 || i.maxLimitValue || i.maxLimitValue === 0 || i.maxLimitValue || i.maxLimitValue === 0
      this.$emit('change', filterAction)
    },
  }
}
</script>
<style lang="scss" scoped>
  .menu {
    padding:5px 15px;
    ::v-deep .ant-radio-wrapper{
      display: block;
      margin:10px 0;
    }
  }
</style>
